/**
 @ngdoc directive
 @name progressBar

 @description
 Lists progress timeline tabs highlighting completed and active steps.

 @usage
 <progress-bar data="${statusList as JSON}" active-index="${activeIndex}"></progress-bar>

 @param {data}  json data                       - List of progress tabs
 @param {active-index}  int                     - Active tab index

 */

(function() {
    'use strict';
    var progressBar = function ($templateCache) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            bindToController: {
                data: "=",
                activeIndex: "@"
            },
            controllerAs: "ctrl",
            scope: true,
            template: $templateCache.get('components/progressBar.html'),
            controller: function() {
            }
        };
    };

    progressBar.$inject = ['$templateCache'];
    angular.module('app').directive('progressBar', progressBar);

}());